import { QuoteSlotComponent } from '#pplx/frontend/composer-sdk-plugins/quote/QuoteSlotComponent.js';
import { createPluginFactory } from '#pplx/frontend/composer-sdk/plugins/createPluginFactory.js';
/**
 * Builds the named quote plugin factory. Each `factory(props)` call yields a
 * fresh instance with stable identity carrying live props (the quoted text and
 * optional accessory and close callback) into the composer `inputHeader` slot.
 * Product copy arrives localized; dismissal uses the Aether provider's close label.
 */
export function createQuotePluginFactory() {
    return createPluginFactory({
        name: 'quote',
        hasContent: ({ message }) => message.trim().length > 0,
        capabilities: [
            { kind: 'slot', components: [{ slot: 'inputHeader', component: QuoteSlotComponent }] },
        ],
    });
}
//# sourceMappingURL=index.js.map